require('./_wks-define')('observable');


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/es7.symbol.observable.js
// module id = 682
// module chunks = 0 1 2 3 4